import { render } from "./ShareInfo.vue?vue&type=template&id=65409ed2&scoped=true&ts=true"
import script from "./ShareInfo.vue?vue&type=script&lang=ts"
export * from "./ShareInfo.vue?vue&type=script&lang=ts"

import "./ShareInfo.vue?vue&type=style&index=0&id=65409ed2&lang=postcss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65409ed2"]])

export default __exports__